import { background, BackgroundProps, color, ColorProps } from 'styled-system';
import { css } from '~ui-kit/styled-components';
import { applyTransientProps, PrependDollar } from './styled-system-helpers';

/**
 * color
 */
export type StyledColorProps = PrependDollar<ColorProps>;

export const styledColor = <T extends StyledColorProps>(props: T) => applyTransientProps(props, color);

/**
 * background, bg
 */
export type StyledBackgroundProps = PrependDollar<BackgroundProps>;

export const styledBackground = <T extends StyledBackgroundProps>(props: T) => applyTransientProps(props, background);

/**
 * Combine color and background
 */
export type StyledColoringProps = StyledColorProps & StyledBackgroundProps;

export const styledColoring = css<StyledColoringProps>`
  ${styledColor}
  ${styledBackground}
`;
